import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const useRegistrationRedirect = () => {
  return usePagesRedirect('registration');
};
